import React, { FC, useRef, useMemo, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { StepperRefProps } from 'src/front/components/StepperView';
import Application from 'src/front/components/Application';
import ViewCreditsProvider from 'src/front/contexts/ViewCreditsContext';
import ClientSearch from './ClientSearch';
import ViewCreditResults from './ViewCreditResults';

const ViewCredits: FC = () => {
  const { t } = useTranslation();
  const stepperRef = useRef<StepperRefProps>(null);

  const goToNextStep = async (): Promise<void> => {
    stepperRef.current?.goToNextStep();
  };
  const steps = [
    {
      component: () => <ClientSearch goToNextStep={goToNextStep} />,
    },
    {
      component: () => <ViewCreditResults />,
    },
  ];
  const stepsVertical = useMemo(() => {
    const stepDefinitions = [
      {
        text: t('viewCredits_stepper_clientSearch_text'),
      },
      {
        text: t('viewCredits_stepper_viewCredits_text'),
      },
    ];
    return stepDefinitions.map((item, index) => ({
      text: item.text,
      index: index + 1,
    }));
  }, [t]);

  return (
    <Application stepperRef={stepperRef} steps={steps} stepsVertical={stepsVertical} isCompleted />
  );
};
export default (): ReactElement => (
  <ViewCreditsProvider>
    <ViewCredits />
  </ViewCreditsProvider>
);
